import { Component } from '@angular/core';

declare const MW: any;
declare const pc: any;
declare const setupScene: any;
declare const MAP: any;

@Component({
  selector: 'app1',
  templateUrl: './app1.component.html'
})
export class App1Component {
  data = {};

  ngOnInit() {
    var that = this;
    var data = {};
    var scene = setupScene("canvas1");  
    var font = new pc.Asset('Arial.json', "font", { url: "../../../libs/playcanvas/Arial.json" });
    
    scene.assets.on('load', function () {

        var text = new pc.Entity("text", scene);
        text.addComponent("element", {
            type: "text",
            anchor: [0, 0, 0, 0],
            pivot: [0.5, 0.5],
            fontSize: 16,
            fontAsset: font,
            opacity: 1,
            color: [0, 0, 1],
            shadowColor: [0, 0, 1],
            shadowOffset: [0.2, -0.2],
            text: "Hello World!"
        });
        text.setLocalScale(1 / 32, 1 / 32, 1 / 32);
        scene.root.addChild(text);

        new MW.TwoWayMap({
            end1: data,
            map1: MAP.TEXT.to3DModel,
            end2: text,
            map2: MAP.TEXT.toDataModel,
            data1: {
                text: 'Hello world!',
                diffuseColor: '#dd3300',
                outlineColor: '#ee9966'
            }
        });
        that.data = data;
    });

    scene.assets.add(font);
    scene.assets.load(font);
  }
}